const translations = {
    applicationSite: 'Application Site',
    hideMap: 'Hide Map',
    latitude: 'Latitude',
    longitude: 'Longitude',
    showMap: 'Show Map'
};

export default translations;
